module.exports = "<div class=\"container\">\n  <h2 class=\"mt4 mb2 center\">{{t('title')}}</h2>\n  <div v-for=\"shop in shops\" class=\"container\">\n    <div class='col-5 mx-auto center mb2' style='background-color: #eee'>\n      <span class='block'>{{shop.address[0]}}</span>\n      <span class='block'>{{shop.address[1]}}</span>\n      <span class='block'>{{shop.address[2]}}</span>\n      <span class='block'>{{shop.address[3]}}</span>\n      <a class='block' :href='shop.web'>{{shop.desc}}</a>\n    </div>\n  </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./lib/shops/index.html
// module id = 59
// module chunks = 0